import { createAction } from "@reduxjs/toolkit";
import {
	BulkToggleWorkspaceRadioChannelsRequest,
	BulkToggleWorkspaceRadioChannelsResponse,
	CreateWorkspaceRadioChannelResponse,
	WorkspaceRadioChannelDto,
	WorkspaceRadioChannelUpdatedDto,
} from "@somewear/api";
import { createActionSet } from "@somewear/model";
import { WorkspaceRadioChannelRequest } from "@somewear/radio";

export const emitWorkspaceRadioChannelReceived = createAction<WorkspaceRadioChannelDto.AsObject>(
	"emitWorkspaceRadioChannelReceived",
);

export const emitWorkspaceRadioChannelUpdated =
	createAction<WorkspaceRadioChannelUpdatedDto.AsObject>("emitWorkspaceRadioChannelUpdated");

export const workspaceRadioChannelActions = {
	queueWorkspaceRadioChannelToggle: createAction<Map<string, boolean>>(
		"queueWorkspaceRadioChannelToggle",
	),
	createWorkspaceRadioChannel: createActionSet<
		WorkspaceRadioChannelRequest,
		CreateWorkspaceRadioChannelResponse.AsObject
	>("workspace/radioChannel/create"),
	bulkToggleWorkspaceRadioChannels: createActionSet<
		BulkToggleWorkspaceRadioChannelsRequest.AsObject,
		BulkToggleWorkspaceRadioChannelsResponse.AsObject
	>("workspace/radioChannel/toggle"),
};
